import { closeSplitView } from '@saaga/shared/store/slices/split-view.slice'
import { useAppDispatch } from '@saaga/shared/store/store'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export const useCloseSplitViewOnRouteChange = (): void => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const previousPathnameRef = useRef(location.pathname)

  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname) {
      dispatch(closeSplitView())
      previousPathnameRef.current = location.pathname
    }
  }, [location.pathname, dispatch])
}
